import _jsx from "@babel/runtime/helpers/jsx";
/* global OneTrust */
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Glyphicon, ToggledDropdown } from 'reaxl';

/**
 *  Sitemap generates a sitemap in the form of an toggled dropdown for mobile devices and columned link sections for larger viewports
 *
 */

const getColumn = column => [].concat(column);
const renderSitemapItem = (_ref, index, onClick, enableOneTrustFooter) => {
  let {
    text,
    pagetype,
    glyph,
    img,
    ...itemRest
  } = _ref;
  const isOneTrust = text === 'Manage Cookies';
  if (isOneTrust && !enableOneTrustFooter) {
    return null;
  }
  return /*#__PURE__*/_jsx("li", {
    className: "margin-top-2"
  }, `${itemRest.href}/${pagetype}-${index}`, /*#__PURE__*/React.createElement("a", Object.assign({}, itemRest, onClick && {
    onClick: e => {
      const data = {
        type: 'main',
        text,
        pagetype
      };
      onClick(e, data);
      if (isOneTrust && enableOneTrustFooter) {
        e.preventDefault();
        OneTrust?.ToggleInfoDisplay();
      }
      return true;
    }
  }, {
    className: "link-undecorated"
  }), text, glyph && /*#__PURE__*/_jsx(Glyphicon, {
    className: "margin-left-2",
    glyph: glyph
  })));
};
const renderSingleDropdown = (_ref2, onClick, enableOneTrustFooter) => {
  let {
    title,
    items
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: "dropdown"
  }, title, /*#__PURE__*/_jsx(ToggledDropdown, {
    containerElement: "div",
    collapseElement: "ul",
    collapseClassName: "list-unstyled",
    className: "dropdown-panel-content",
    showCaret: false,
    labelText: title,
    id: title.replace(/\s/ig, ''),
    closeGlyph: "menu-up",
    openGlyph: "menu-down"
  }, title.replace(/\s/ig, ''), items.map((item, index) => renderSitemapItem(item, index, onClick, enableOneTrustFooter))));
};
const renderColumns = (data, colNumber, onClick, enableOneTrustFooter) => data.map((column, index) => /*#__PURE__*/_jsx("div", {
  className: `sitemap-column col-sm-${colNumber}`
}, `column-${index}-${colNumber}`, getColumn(column).map(item => renderSingleDropdown(item, onClick, enableOneTrustFooter))));
function StaticSitemap(_ref3) {
  let {
    data = [],
    onClick,
    className,
    enableOneTrustFooter,
    ...rest
  } = _ref3;
  const colNumber = Math.round(12 / data.length);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "sitemap",
    className: clsx('sitemap display-flex gap-sm-5 flex-column row flex-sm-row', className)
  }, rest), renderColumns(data, colNumber, onClick, enableOneTrustFooter));
}
export default StaticSitemap;